import { eventManager } from './eventManager';

export class BaseRedirect {
	async redirectTo(redirectURL: string) {
		// Flush all pending events before redirecting to bank (non-blocking - failures won't prevent redirect)
		try {
			await eventManager.flushEventsAsync();
		} catch {
			// Ignore errors - redirect should always happen
		}
		window.location.assign(redirectURL);
	}
}

export const RedirectService = new BaseRedirect();
